<script setup>
/**
 * @fileoverview Laticrete grout color picker. Joint width is fixed at 3/16".
 *
 * @component
 */
import { useMosaicStore } from '../stores/mosaicStore';
import { trackGroutSelection } from '../utils/trackingService';

const store = useMosaicStore();

function select(grout) {
    if (grout.id === store.groutId) return;
    store.setGrout(grout.id);
    trackGroutSelection(grout);
}
</script>

<template>
    <div class="flex flex-col gap-2">
        <p class="text-xs text-dryline mb-0">
            Selected:
            <strong class="text-black">{{ store.groutColor?.name }}</strong>
            ({{ store.groutColor?.code }}) · 3/16" joint
        </p>
        <div class="grid grid-cols-8 gap-1.5" role="group" aria-label="Grout colors">
            <button
                v-for="g in store.groutColors"
                :key="g.id"
                type="button"
                class="aspect-square border transition focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-1"
                :class="
                    store.groutId === g.id
                        ? 'border-dryline ring-2 ring-dryline ring-offset-1'
                        : 'border-engobe hover:border-dryline'
                "
                :style="{ backgroundColor: g.hex }"
                :title="`${g.name} (${g.code})`"
                :aria-label="`${g.name} grout (${g.code})`"
                :aria-pressed="store.groutId === g.id ? 'true' : 'false'"
                @click="select(g)"
            />
        </div>
        <p class="text-[11px] text-dryline mb-0">Grout swatches are approximate screen colors.</p>
    </div>
</template>
